<template>
  <div class="has-background-grey-lighter has-text-black-bis card-tab-details" v-if="dataLoaded">
    <div class="column">
      <div class="columns">
        <div class="column">
          <div class="has-background-white project-details-col is-border-radius-sm has-text-black-bis p-3">
            <div class="columns">
              <div class="column is-10">
                <h3 class="is-size-3 has-text-weight-bold line-height">Oracle Primavera Cloud (OPC)</h3>
              </div>
              <div class="column" v-if="!updatePassword">
                <div class="buttons is-pulled-right">
                  <button v-if="isopcEdit" class="button is-outlined p-0" @click="toggleOpcEdit()" v-tooltip="'Cancel'">
                    <i class="icon-close is-clickable"></i>
                  </button>
                  <button v-if="isopcEdit" class="button has-background-black-bis has-text-white p-0" @click="save"
                    v-tooltip="'Save'" :disabled="!projectId">
                    <i class="icon-checkmark has-text-white"></i>
                  </button>

                  <button :disabled="opcEdit || alreadyLinked" class="button has-text-black-bis p-0"
                    @click="toggleOpcEdit()" v-tooltip="'Edit'" v-if="!isopcEdit">
                    <i class="icon-edit"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="columns">
              <div v-if="!isopcEdit">
                <p class="is-size-3 has-text-black-bis line-height ml-3 has-text-weight-semibold"
                  v-if="!project.opcCred">OPC has been not
                  configured for this Project.</p>
                <div class="column" v-else>
                  <div class="columns">
                    <div class="column">
                      <p class="is-size-3 has-text-black-bis line-height has-text-weight-semibold">
                        OPC URL</p>
                      <p class="is-size-3 has-text-black-bis line-height has-text-weight-normal"> {{
                        project.opcCred.opcUrl }}</p>
                      <div v-if="!updatePassword">
                        <p class="is-size-3 has-text-black-bis line-height  has-text-weight-semibold">
                          OPC Project
                        </p>
                        <p class="is-size-3 has-text-black-bis line-height  has-text-weight-normal">{{
                          project.opcCred.name }}</p>
                      </div>

                      <p class="is-size-3 has-text-black-bis line-height  has-text-weight-semibold">
                        User Name
                      </p>
                      <p class="is-size-3 has-text-black-bis line-height  has-text-weight-normal">
                        {{ project.opcCred.userName }}
                      </p>
                      <div v-if="!updatePassword" class="is-size-3 has-text-black-bis line-height">
                        <p class=" has-text-weight-semibold line-height">Password</p>
                        <p class="has-text-weight-normal line-height">**************</p>

                      </div>
                      <div v-if="updatePassword" class="is-size-3 has-text-black-bis line-height">
                        <p class=" has-text-weight-semibold line-height">
                          Password
                        </p>
                        <div class="control has-icons-left has-icons-right">
                          <input v-if="updatePassword" class="input generic-input"
                            :type="showPassword ? 'text' : 'password'" v-model="password" />

                          <span class="icon is-right is-clickable" @click="showPassword = !showPassword">
                            <i :class="showPassword ? 'icon-hide' : 'icon-show'"></i>
                          </span>
                        </div>


                      </div>
                    </div>

                  </div>

                  <div class="buttons is-right" v-if="!updatePassword">
                    <button class="button has-background-black-bis is-pulled-right" type="button"
                      @click="updatePassword = true">
                      Update
                    </button>
                  </div>
                  <div class="buttons is-right" v-if="updatePassword">
                    <button class="button is-cancel" type="button" @click="updatePassword = false">
                      Cancel
                    </button>
                    <button class="button has-background-black-bis is-pulled-right" type="button"
                      @click="changePassword()">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <div class="column" v-if="isopcEdit && !isLoadingVisible">
                <div class="columns is-multiline">
                  <div class="column">
                    <p class="is-size-3 has-text-black-bis line-height has-text-weight-semibold">OPC URL</p>
                    <input v-model.trim="opcUrl" class="input" :disabled="alreadyLinked || isOpcProjLoaded"
                      placeholder="OPC URL" />
                  </div>

                </div>
                <div class="columns" v-if="!isOpcProjLoaded">
                  <div class="column">
                    <p class="is-size-3 has-text-black-bis line-height has-text-weight-semibold">OPC User
                      Name</p>
                    <input v-model.trim="userName" class="input" :disabled="alreadyLinked || isOpcProjLoaded"
                      placeholder="User Name" />
                  </div>
                </div>
                <div class="columns" v-if="!isOpcProjLoaded">
                  <div class="column">
                    <p class="is-size-3 has-text-black-bis line-height  has-text-weight-semibold">OPC Password</p>
                    <div class="control  has-icons-right">
                      <input class="input generic-input" :type="showPassword ? 'text' : 'password'"
                        v-model="password" />
                      <span class="icon is-right is-clickable" @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'icon-hide' : 'icon-show'"></i>
                      </span>
                    </div>
                  </div>

                </div>
                <div class="columns" v-if="!isOpcProjLoaded">
                  <div class="column">
                    <button class="button has-background-black-bis is-pulled-right has-text-white" type="button"
                      @click="getOpcProjects()" :disabled="!(opcUrl && userName && password)">
                      Submit
                    </button>
                  </div>
                </div>
                <div v-if="isOpcProjLoaded">
                  <div class="columns">
                    <div class="column">
                      <p class="is-size-3 has-text-black-bis line-height has-text-weight-semibold">
                        Project Id
                      </p>
                      <mf-multi-select v-model="selectedOpcProject" class="is-pulled-right pendo-pm-default-tab-select"
                        :options="opcProjects" :multiple="false" @select="setProject" openDirection="below" label="name"
                        track-by="projectId" :allow-empty="false">
                      </mf-multi-select>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <p class="is-size-3 has-text-black-bis line-height  has-text-weight-semibold">
                        <o-checkbox v-model="configField" class="is-pulled-left pl-0">
                        </o-checkbox>
                        Only add Activities with "Send to Manufacton" configured field
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="has-background-white project-details-col is-border-radius-sm p-3">
            <submittal ref="submittal" :locations="project.projectLocations" :project="project" :type="'projectSetting'" :key="refreshSubmittal"
              :saveProject="saveProject" :editSubmittal="true">
            </submittal>
          </div>
        </div>
        <div class="column">
          <div class="has-background-white project-details-col is-border-radius-sm p-3">
            <div class="columns">
              <div class="column">
                <h3 class=" is-size-3 has-text-weight-bold line-height">Linked Project/Model</h3>
              </div>
              <div class="column is-flex is-justify-content-end">
                <div class="buttons">
                  <button v-if="isbimEdit" class="button is-outlined p-0" @click="togglebimEdit()" v-tooltip="'Cancel'"
                    v-permission="{
                      permissionModule: 'app&projects', type: 'alterProject',
                      project: project
                    }">
                    <i class="icon-close is-clickable"></i>
                  </button>
                  <button v-if="isbimEdit" class="button is-success p-0" @click="bimSave" v-tooltip="'Save'">
                    <i class="icon-checkmark has-text-white"></i>
                  </button>
                  <button v-if="!isbimEdit" :disabled="isbimEdit" class="button has-text-black-bis p-0"
                    @click="togglebimEdit()" v-tooltip="'Edit'" v-permission="{
                      permissionModule: 'app&projects', type: 'alterProject',
                      project: project
                    }">
                    <i class="icon-edit"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="columns">
              <div v-if="!isbimEdit && hasModelLinked" class="column">
                <p class="has-text-black-bis is-size-3 line-height">
                  No Linked Project or Model
                </p>
              </div>
              <div v-if="isbimEdit && !isAuthorized">
                <p class="has-text-black-bis is-size-3 line-height">
                  No Linked Project or Model
                </p>
                <p>You must authorize ALLPALN/BIMPLUS or ACC/BIM360 before linking the project model</p>
                <button class="button has-background-black-bis has-text-white" @click="manageIntegrations">
                  Manage Integrations
                </button>
              </div>
              <div v-if="isbimEdit && hasModelLinked && isAuthorized">
                <p class="has-text-black-bis is-size-3 line-height"><span class="has-text-weight-semibold">NOTE:</span>
                  A Manufacton project can
                  only be linked to a single project/model source (BIMPLUS or ACC/BIM360). The source cannot be changed
                  once the linking is complete.
                </p>
                <div class="column">
                  <h3 class="has-text-weight-semibold is-size-3 has-text-black-bis">Link BIMPLUS Project</h3>
                  <p class="has-text-black-bis is-size-3 line-height">Link Manufacton project to BIMPLUS project and
                    model(s).</p>
                  <button class="button has-background-black-bis has-text-white" @click="linkBimPlusModel">
                    Link BIMPLUS Project
                  </button>
                </div>
                <div class="column">
                  <h3 class="has-text-weight-semibold is-size-5">Link ACC/BIM 360 Model</h3>
                  <p class="has-text-black-bis is-size-3 line-height">Link Manufacton project to an ACC/BIM360 model.
                  </p>
                  <button class="button  has-background-black-bis has-text-white" @click="linkBim360Model">
                    Link ACC/BIM 360 Model
                  </button>
                </div>
              </div>
              <div v-if="!hasModelLinked" class="column ">
                <div class="columns is-multiline pl-3">
                  <div class="column is-full">
                    <h3 class="has-text-weight-semibold is-size-3 line-height">{{ modelSourceText }}</h3>
                    <p v-if="isBimplusProject" class="is-size-3 line-height">{{ projectSettings.bimplusSync.project.name
                      }} </p>
                    <div v-if="isbimEdit" class="is-flex is-align-items-center">
                      <button class="button has-background-black-bis has-text-white" @click="setLinkedModel">
                        {{ changeBimButtonText }}
                      </button>
                      <o-checkbox v-if="!isBimplusProject" v-model="isCheckedAutoFresh" @update:modelValue="onAutoFreshcheckchange" :disabled="disableAutoRefresh">
                        <p class="has-text-weight-normal has-text-black-bis"> Auto Refresh </p>
                      </o-checkbox>
                    </div>
                    <div v-else>
                      <button class="button has-background-black-bis has-text-white" @click="redirectUrl()">
                        View Model(s)
                      </button>

                    </div>
                    <h3 class="is-size-3 has-text-black-bis line-height"><span
                        class="has-text-weight-semibold mr-2 is-pulled-left">Model Source: </span>
                      <span class="">{{ projectSettings.bimplusSync.modelSource }}</span>
                    </h3>
                  </div>
                  <div class="column is-full pl-0">
                    <div v-if="isBimplusProject && projectSettings.bimplusSync.modelSource !== 'SDS2'">
                      <p class="has-text-weight-semibold is-size-3 line-height ml-3">Manufacton + BIMPLUS Grouping
                        Property</p>
                      <p class="is-size-3 ml-3">Required for creating Production Orders from model object groups.</p>
                      <div class="column">
                        <div class="columns is-align-items-center">
                          <div class="column is-5">
                            <span class="is-size-3 has-text-weight-semibold">Grouping Property 1:</span>
                          </div>
                          <div class="column integrations-col">
                            <span v-if="!isbimEdit" class="is-size-3 line-height has-text-black-bis ">{{
                              groupingProperty1 }}</span>
                            <input class="input generic-input" v-else v-model.trim="groupingProperty1" />
                          </div>
                        </div>
                      </div>

                      <div class="column">
                        <p class="has-text-weight-semibold is-size-3 line-height">Manufacton + BIMPLUS Property
                          Association</p>
                        <p class="is-size-3 line-height">
                          Required when creating Production Orders from model objects with
                          associated Material Requests.
                        </p>
                        <div class="columns is-align-items-center mb-3">
                          <div class="column is-5">
                            <span class="is-size-3 has-text-weight-semibold">Catalog ID:</span>
                          </div>
                          <div class="column integrations-col">
                            <span v-if="!isbimEdit" class="is-size-3 line-height has-text-black-bis ">{{
                              catalogIdProperty.value }}</span>
                            <input v-else v-model.trim="catalogIdProperty.value" class="input generic-input" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
              <div class="has-text-black-bis">
                <BimFileAccess v-if="bimModal" :isComponentModalActive="bimModal" :project="project"
                  @close-modal="bimModal = false" @set-urn="setForgeSyn($event)">
                </BimFileAccess>
                <BimPlusModelList v-if="showbimPlusModelList" :isComponentModalActive="showbimPlusModelList"
                  :project="project" @close-modal="closeBimPlusModel">
                </BimPlusModelList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <o-loading :active="isLoading" />
  </div>
</template>

<script>

import { computed, onMounted, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useToast } from "vue-toastification";
import { get, isEmpty, find, pick, debounce, assign, set } from 'lodash';

import { DialogProgrammatic } from '@/components/Dialog';
import BimFileAccess from '@/components/BimFileAccess.vue';
import BimPlusModelList from '@/components/BimPlusModalList.vue';
import Submittal from '@/components/Submittal.vue';
import Projects from '@/models/Projects';
import Forge from '@/models/Forge';
import User from '@/models/Users';


export default {
  name: 'ProjectIntegrations',
  components: {
    BimPlusModelList,
    BimFileAccess,
    Submittal,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toast = useToast();
    const router = useRouter();
    const store = useStore();
    const data = reactive({
      project: props.rowData,
      propertyEnum: Object.freeze({
        GROUPING_PROPERTY1: 'Grouping Property 1',
        CATALOGID: 'Catalog ID'
      }),
      dataLoaded: false,
      user: {},
      isLoadingVisible: false,
      isopcEdit: false,
      opcEdit: false,
      isbimEdit: false,
      bimEdit: false,
      isEdit: false,
      isCheckedAutoFresh: false,
      companies: [],
      projects: [],
      generalSettings: {},
      opcUrl: '',
      userName: '',
      password: '',
      projectId: '',
      alreadyLinked: false,
      opcValue: '',
      projectSettings: {},
      isautoRefresh: false,
      bimModal: false,
      showbimPlusModelList: false,
      loadingComp: null,
      opcProjects: [],
      selectedOpcProject: {},
      isOpcProjLoaded: false,
      updatePassword: false,
      showPassword: false,
      configField: false,
      isBimplusProject: false,
      forgeRefreshEvt: false,
      isLoading: false,
      bimProjectSettingsSnapshot: null,
      refreshSubmittal: 0,
      projectClone: {},
    });

    const toggleOpcEdit = () => {
      data.isopcEdit = !data.isopcEdit;
    };

    const togglebimEdit = (shouldReset = true) => {
      if (!data.isbimEdit) {
        data.bimProjectSettingsSnapshot = _.cloneDeep(data.projectSettings);
        data.isbimEdit = true;
      } else {
        if (shouldReset && data.bimProjectSettingsSnapshot) {
          const companyId = data.user.company && (data.user.company._id || data.user.company);
          const settingIdx = _.findIndex(data.project.projectSettings, { companyId });
          const restoredSettings = _.cloneDeep(data.bimProjectSettingsSnapshot);

          data.projectSettings = restoredSettings;
          if (settingIdx !== -1) {
            _.set(data.project.projectSettings, settingIdx, _.cloneDeep(restoredSettings));
          }
        }
        data.bimProjectSettingsSnapshot = null;
        data.isbimEdit = false;
      }
    };

    const toggleEdit = () => {
      if (data.alreadyLinked) {
        toast.warning('This project is already linked to a Procore project');
      } else {
        data.isEdit = !data.isEdit;
      }
    };

    const bimSave = async () => {
      if (data.isBimplusProject && data.projectSettings.bimplusSync.modelSource !== 'SDS2' && (_.isEmpty(groupingProperty1.value))) {
        toast.error('Grouping Property is required');
      } else {
        await saveProject('bim');
        emit('forceRerender');
      }
    };

    const closeBimPlusModel = async (obj) => {
      data.showbimPlusModelList = false;
      if (obj && obj.reRender) {
        await getProject();
        const companySetting = find(data.project.projectSettings, (setting) => setting.companyId === (data.user.company._id || data.user.company));
        set(companySetting, 'bimplusBindings', data.projectSettings.bimplusBindings);
        data.projectSettings = companySetting;
      }
    };

    const redirectUrl = async () => {
      const bimProject = await Projects.get(data.project._id);
      if (data.isBimplusProject) {
        if (!_.isEmpty(store.state.bimplus.access_token) && !isTokenExpired(store.state.bimplus.expires_at)) {
          let bimPlusTeamSlug = data.project.projectSettings[0].bimplusSync.team.id;
          let bimPlusprojectId = data.project.projectSettings[0].bimplusSync.project.id;
          const baseUrl = window.location.hostname === "app.manufacton.com" ? 'https://portal.bimplus.net' : 'https://portal-stage.bimplus.net';
          window.open(`${baseUrl}/viewer/#/viewer?project_id=${bimPlusprojectId}&team_id=${bimPlusTeamSlug}`, '_blank');


          // const Params = {
          //   module: 'viewer',
          //   projectId: data.project._id,
          // };
          // const Query = { from: 'projectSettings'};
          // const data = { pathInfo: { name: 'bimplus-view', params: Params, query: Query}};
          // window.parent.postMessage(JSON.stringify(data), '*');
        } else {
          toast.warning('Token got expired. Kindly re-authorize');
          router.push({
            name: 'user-settings',
            params: {
              refreshToken: true,
            }
          });
        }
      } else {
        data.projectSettings.forgeSync.urn = bimProject.projectSettings[0].forgeSync.urn;
        if (data.projectSettings.forgeSync.urn) {
          const Params = {
            module: 'viewer',
            projectId: data.project._id,
            urn: data.projectSettings.forgeSync.urn,
          };
          const bimData = { pathInfo: { name: 'lmv-view', params: Params } };
          window.parent.postMessage(JSON.stringify(bimData), '*');
        } else {
          toast.warning('Token got expired. Kindly re-authorize');
          router.push({
            name: 'user-settings',
            params: {
              refreshToken: true,
            }
          });
        }

      }

    }

    const refreshUrnConfirm = () => {
      const confirmParams = {
        title: 'REFRESH MODEL',
        message: `Manufacton will now automatically display new model versions.`,
        okButton: 'OK',
        cancelButton: 'Cancel',
        type: 'is-warning',
        note: 'NOTE: This action will refresh the model and display the latest versions.',
        noteType: 'is-warning',
        onConfirm: async () => {
          try {
            data.isLoading = true;
            await refreshUrn();
          } catch (error) {
            toast.error(`Error while refreshing model - ${error.data}`);
          } finally {
            await getProject();
            togglebimEdit(false);
            data.isLoading = false;
          }
        },
        onClose: () => {
          data.isCheckedAutoFresh = !data.isCheckedAutoFresh;
        }
      };
      DialogProgrammatic.confirm(confirmParams);
    }

    const isHookEnabled = computed(() => {
      let hookid = get(data.project.projectSettings, 'forgeHook.info.body.id', '');
      if (hookid === '') {
        const hookurl = get(data.project.projectSettings, 'forgeHook.info.headers.location', '').split('/');
        hookid = hookurl[hookurl.length - 1];
      }
      return !isEmpty(hookid);
    });

    const catalogIdProperty = computed({
      get: () => {
        const bimplusProperties = get(data.projectSettings, 'bimplusBindings.bimplusProperties', []);
        return (bimplusProperties.find(p => p.name === data.propertyEnum.CATALOGID)) || { name: data.propertyEnum.CATALOGID, value: '' };
      },
      set: (val) => {
        const bimplusProperties = get(data.projectSettings, 'bimplusBindings.bimplusProperties');
        if (!Array.isArray(bimplusProperties)) {
          _.set(data.projectSettings, 'bimplusBindings.bimplusProperties', []);
        }
        const safeBimplusProperties = get(data.projectSettings, 'bimplusBindings.bimplusProperties', []);
        let catID = safeBimplusProperties.find(p => p.name === data.propertyEnum.CATALOGID);
        if (!catID) {
          catID = { name: data.propertyEnum.CATALOGID, value: '' };
          safeBimplusProperties.push(catID);
        }
        catID.value = val;
      },
    });

    const linkBimPlusModel = () => {
      const titlemsg = 'Link BIMPLUS Project';
      const msg = 'Linking a BIMPLUS project to Manufacton creates a permanent project-to-project link that cannot be undone.';
      const confirmParams = {
        title: titlemsg,
        message: msg,
        okButton: 'OK',
        cancelButton: 'Cancel',
        type: 'is-warning',
        note: 'NOTE: This action will link the Manufacton project to a BIMPLUS project and model(s).',
        noteType: 'is-warning',
        onConfirm: async () => {
          try {
            data.showbimPlusModelList = true;
          } catch (error) {
            toast.error(`Error while linking BIMPLUS project - ${error.data}`);
          }
        },
      };
      DialogProgrammatic.confirm(confirmParams);
    };

    const changeBimButtonText = computed(() => {
      let message;
      if (data.isBimplusProject) {
        message = 'Change BIMPLUS Project';
      } else {
        message = 'Change Model';
      }
      return message;
    });

    const groupingProperty1 = computed({
      get: () => {
        const groupingProperties = get(data.projectSettings, 'bimplusBindings.groupingProperties', []);
        return ((groupingProperties.find(p => p.name === data.propertyEnum.GROUPING_PROPERTY1)) || { name: data.propertyEnum.GROUPING_PROPERTY1, value: '' }).value;
      },
      set: (val) => {
        const groupingProperties = get(data.projectSettings, 'bimplusBindings.groupingProperties');
        if (!Array.isArray(groupingProperties)) {
          _.set(data.projectSettings, 'bimplusBindings.groupingProperties', []);
        }
        const safeGroupingProperties = get(data.projectSettings, 'bimplusBindings.groupingProperties', []);
        let grpProperty1 = safeGroupingProperties.find(p => p.name === data.propertyEnum.GROUPING_PROPERTY1);
        if (!grpProperty1) {
          grpProperty1 = { name: data.propertyEnum.GROUPING_PROPERTY1, value: '' };
          safeGroupingProperties.push(grpProperty1);
        }
        grpProperty1.value = val;
      },
    });

    const linkBim360Model = async () => {
      const user = await User.getUser();
      if( user !== null && !user.forgeCredentials) {
        toast.warning('Please authorize Autodesk Forge to link ACC/BIM360 model');
        router.push({ 
          name: 'user-settings',
          params: {
            refreshToken: true,
          }
        });
        return;
      }
      const titlemsg = 'Link ACC/BIM 360 Model';
      const msg = 'Once a ACC/BIM 360 link is made,it cannot be undone.However,you can change the linked project model to another ACC/BIM 360 model.';
      const confirmParams = {
        title: titlemsg,
        message: msg,
        okButton: 'OK',
        cancelButton: 'Cancel',
        type: 'is-warning',
        note: 'NOTE: This action will link the Manufacton project to a ACC/BIM 360 model.',
        noteType: 'is-warning',
        onConfirm: async () => {
          try {
            data.bimModal = true;
          } catch (error) {
            toast.error(`Error while linking ACC/BIM 360 model - ${error.data}`);
          }
        },
      };
      DialogProgrammatic.confirm(confirmParams);
    };

    const manageIntegrations = () => {
      router.push({
        name: 'user-settings',
        params: {
          refreshToken: true,
        }
      });
    };

    const modelSourceText = computed(() => {
      let message;
      if (get(data.projectSettings.forgeSync, 'urn')) {
        message = 'Linked BIM360 Model';
      } else if (get(data.projectSettings.bimplusSync, 'team')) {
        message = 'Linked BIMPLUS Project';
        data.isBimplusProject = true;
      }
      return message;
    });

    const deleteHookConfirm = () => {
      const msg = `Manufacton will not automatically display new model versions. 
      You will have to manually re-link the model to see new versions. Continue?`;
      const confirmParams = {
        title: 'Unlink Model',
        message: msg,
        okButton: 'OK',
        cancelButton: 'Cancel',
        type: 'is-warning',
        note: 'NOTE: This action will unlink the model and stop automatic updates.',
        noteType: 'is-warning',
        onConfirm: async () => {
          try {
            data.isLoading = true;
            await deleteHook();
          } catch (error) {
            toast.error(`Error while unlinking model - ${error.data}`);
          } finally {
            await getProject();
            togglebimEdit(false);
            data.isLoading = false;
          }
        },
        onClose: () => {
          data.isCheckedAutoFresh = !data.isCheckedAutoFresh;
        }
      };
      DialogProgrammatic.confirm(confirmParams);
    };

    const hasModelLinked = computed(() => {
      return isEmpty(get(data.projectSettings.forgeSync, 'urn')) && isEmpty(get(data.projectSettings.bimplusSync, 'team.id'));
    });

    const isAuthorized = () => {
      return !isEmpty(get(data.projectSettings.forgeSync, 'urn')) || !isEmpty(store.state.bimplus.access_token);
    };

    const disableAutoRefresh = computed(() => {
      return isEmpty(get(data.projectClone.projectSettings[0].forgeSync, 'urn')) || isEmpty(get(data.projectClone.projectSettings[0], 'forgeSync'));
    });

    const deleteHook = async () => {
      data.isautoRefresh = true;
      try {
        await Forge.deleteWebhook(data.project);
        data.projectSettings.forgeHook = {};
        toast.warning('Model must be manually re-linked when model changes');
      } catch (e) {
        toast.error(`Error: ${e.data.error}: please contact ManufactOn support`);
      }
      data.isautoRefresh = false;
      emit('forceRerender');
    };

    const setForgeSyn = async (bimData) => {
      data.isLoading = true;
      const [linkedProj] = await Projects.allProjects({ forgeModel: bimData });
      if (!isEmpty(linkedProj) && linkedProj._id !== data.project._id) {
        const errMsg = `The model you are linking is already linked to project '${linkedProj.name}'. Please select a different model.`;
        toast.error(errMsg);
      } else {
        data.projectSettings.forgeSync.urn = bimData.id;
        assign(data.projectSettings.forgeSync, pick(bimData, ['path', 'itemId', 'folderId', 'projectId']));
        if (!isEmpty(linkedProj) && linkedProj._id === data.project._id) {
          toast.warning('The model is already linked');
        } else {
          toast.success('Your model file selected successfully');
        }
        data.forgeRefreshEvt = true
        data.bimModal = false;
      }
      data.isLoading = false;
    }

    const setProject = (option) => {
      data.projectId = option.projectId;
      data.selectedOpcProject = find(data.opcProjects, { projectId: data.projectId });
    };

    const setLinkedModel = () => {
      if (data.projectSettings.forgeSync.urn) {
        data.bimModal = true;
      } else if (data.projectSettings.bimplusSync.team) {
        if (!isTokenExpired(store.state.bimplus.expires_at)) {
          data.showbimPlusModelList = true;
        } else {
          toast.warning('Token got expired. Kindly re-authorize');
          router.push({
            name: 'user-settings',
            params: {
              refreshToken: true,
            }
          });
        }
      }
    }

    const onAutoFreshcheckchange = () => {
      if (data.isCheckedAutoFresh) {
        refreshUrnConfirm();
      } else {
        deleteHookConfirm();
      }
    };

    const getOpcProjects = debounce(async function getOpcProjects() {
      try {
        data.isLoading = true;
        if (data.opcUrl && data.userName && data.password) {
          data.opcProjects = await Projects.getOpcProjects({
            url: data.opcUrl,
            userName: data.userName,
            password: data.password,
          });
          if (data.opcProjects.length > 0) { data.isOpcProjLoaded = true; }
          return data.opcProjects;
        }
        return [];
      } catch (error) {
        toast.error(`Error: ${error.data.message}`);
        console.log(error);
      } finally {
        data.isLoading = false;
      }
    }, 1000);

    const isTokenExpired = (expiresAt) => {
      if (!expiresAt) return true;
      const currentTime = Math.floor(Date.now() / 1000);
      return currentTime >= expiresAt;
    }

    const refreshUrn = async (rerender = true) => {
      data.isautoRefresh = true;
      try {
        const { id, forgeHook } = await Forge.setForgeDirective(data.project);
        data.projectSettings.forgeSync.urn = id;
        data.projectSettings.forgeHook = forgeHook;
        toast.warning('Model link will be auto-updated when model changes');
      } catch (e) {
        toast.error(`Error: ${e.data.error}: please contact ManufactOn support`);
      }
      data.isautoRefresh = false;
      if (rerender) emit('forceRerender');
    };

    const changePassword = async () => {
      data.isLoading = true;
      try {
        const reqparams = {
          url: data.opcUrl,
          userName: data.userName,
          password: data.password,
          project: data.project._id,
          projectIdOic: data.projectId,
          projectNameOic: data.selectedOpcProject.name,
        };
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Save OPC credentials
        data.opcValue = await Projects.configureOpc(reqparams);

        // Update data.project.opcCred
        _.set(data.project, 'opcCred.password', data.password);
        data.updatePassword = false;
        toast.success('OPC Creds updated');
      } catch (error) {
        console.error('Error saving OPC data:', error);
        toast.error(`Error: ${error.data.message}`);
      } finally {
        data.isLoading = false;
      }
    };

    const saveProject = async (type) => {
      let project;
      data.isLoading = true;
      const projectSettingsIdx = _.findIndex(
        data.project.projectSettings,
        { companyId: data.user.company._id || data.user.company },
      );
      const updatedProjectSettings = data.projectSettings;
      _.set(data.project.projectSettings, projectSettingsIdx, updatedProjectSettings);
      try {
        project = await Projects.update(data.project);
        if (data.forgeRefreshEvt) {
          data.forgeRefreshEvt = false;
          if (data.project.companyProjectSettings) {
            await data.project.companyProjectSettings.refreshUrn(false);
          }
        }
        data.isLoading = false;
        data.newProId = project._id;
        toast.success('Project updated');
      } catch (errors) {
        toast.error(`Error: ${errors.data._errmsg}`);
        data.isLoading = false;
      }
      await getProject();
      if (type === 'submittal') data.refreshSubmittal += 1;
      if (type === 'bim') togglebimEdit(false);
    };

    const getProject = async () => {
      data.project = await Projects.get(data.project._id);
      data.projectClone = _.cloneDeep(data.project);
    };

    onMounted(async () => {
      try {
        await getProject();
        data.user = store.state.userData;
        if (!isEmpty(data.project.projectSettings)
          && (data.project.projectSettings.length !== 0)) {
          data.projectSettings = find(data.project.projectSettings, (setting) => setting.companyId === (data.user.company._id || data.user.company));
        }
        if (isEmpty(data.projectSettings.forgeSync)) {
          data.projectSettings.forgeSync = {};
        }
        if (isEmpty(data.projectSettings.bimplusBindings.groupingProperties)) {
          data.projectSettings.bimplusBindings.groupingProperties.push({ name: data.propertyEnum.GROUPING_PROPERTY1, value: '' });
        }
        if (isEmpty(data.projectSettings.bimplusBindings.bimplusProperties)) {
          data.projectSettings.bimplusBindings.bimplusProperties.push({ name: data.propertyEnum.CATALOGID, value: '' });
        }
        data.opcUrl = get(data.project, 'opcCred.opcUrl', '');
        data.userName = get(data.project, 'opcCred.userName', '');
        data.password = get(data.project, 'opcCred.password', '');
        data.projectId = get(data.project, 'opcCred.projectId', '');
        data.alreadyLinked = !isEmpty(data.project.opcCred);
        data.isCheckedAutoFresh = isHookEnabled.value;
      } catch (error) {
        console.error('Error in onMounted of ProjectIntegrations.vue: ', error);
      } finally {
        data.dataLoaded = true;
      }
    });

    return {
      ...toRefs(data),
      isHookEnabled,
      isAuthorized,
      toggleOpcEdit,
      togglebimEdit,
      toggleEdit,
      bimSave,
      closeBimPlusModel,
      redirectUrl,
      refreshUrnConfirm,
      linkBimPlusModel,
      linkBim360Model,
      manageIntegrations,
      modelSourceText,
      deleteHookConfirm,
      hasModelLinked,
      setForgeSyn,
      setProject,
      setLinkedModel,
      onAutoFreshcheckchange,
      changeBimButtonText,
      isTokenExpired,
      getOpcProjects,
      changePassword,
      groupingProperty1,
      catalogIdProperty,
      getProject,
      saveProject,
      disableAutoRefresh,
    }
  }
}
</script>